import { AfterViewChecked, Component, EventEmitter, Input, NgZone, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService, Message } from 'primeng/api';
import { FAZILService, UserService } from 'src/app/core';
import { UIService } from 'src/app/core/services/ui.service';
import { environment } from 'src/environments/environment';
import { ContactosService } from 'src/app/contactos/contactos.service';
import { SubjectCustomer } from '../modelo/SubjectCustomer';
import { Subject } from '../modelo/Subject';

import { AdministracionService } from 'src/app/administracion/administracion.service';
import { validateDni } from 'src/app/shared/helpers';
import { validateRUC } from 'src/app/shared/helpers';
import { validateEmail } from 'src/app/shared/helpers';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FazilController } from '../core/fazil-controller-component';
import { FormBuilder } from '@angular/forms';
import { SubjectCustomerOutput } from '../core/models/contacto.model';

@Component({
    selector: 'app-contacto',
    templateUrl: './contacto.component.html',
    styleUrls: ['./contactos.component.scss']
})
export class ContactoComponent  extends FazilController implements OnInit,  AfterViewChecked, OnChanges {

    //Variables de configuración/mensajes
    appConfig = environment.settings;

    errors: Object = {};
    msgs: Message[] = [];

    _customer: Subject = new Subject();
    _contacto: SubjectCustomer;

    //Variables auxiliares
    cargandoDataInit: boolean = false;
    procesando: boolean = false;
    buttonsActions: any[] = [];
    
    //code: string;
    verificandoData: any;
    verificando: boolean = false;
    subjectCode: string;
    subjectNUI: string;
    subjectCodeValid: boolean = false;
    emailValid: boolean = true; //Todo correo es valido para el cliente
    enEdicion: boolean = false;

    //Help Section
    safeSrc: SafeResourceUrl;
    display: boolean;

    objNombreSg: string = "contacto";
    objNombrePl: string = "contactos";
    
    etiquetaCIRUC: string = 'C.I';
    
    //interacción con el popup
    _mostrarEditor: boolean = false;
    
    @Output() contactoGuardado = new EventEmitter<SubjectCustomerOutput>();
    
    @Input() estaCargandoDatos: boolean = false;
    
    visible:boolean = false;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private fazilService: FAZILService,
        private confirmationService: ConfirmationService,
        private contactosService: ContactosService,
        private sanitizer: DomSanitizer,
        public override uiService: UIService,
        public override messageService: MessageService,
        public override administracionService: AdministracionService,
        public override _formBuilder: FormBuilder
    ) {
        super(uiService, messageService, administracionService, _formBuilder);
    }
    
    ngOnInit(): void {
        this.initComponent();
    }
    
    ngAfterViewChecked(): void {
        //dummy
    }
    //Detecta los cambios desde fuera del componente
    ngOnChanges(changes: SimpleChanges): void {
        this.visible = (this.mostrarEditor && this.customer !== null);
    }
    
    async initComponent() {
        
        this.estaCargandoDatos = false;
    }
    
    //Accesores
    
    @Input() 
    set mostrarEditor(v){
        this._mostrarEditor = v;
    }
    
    get mostrarEditor(){
        return this._mostrarEditor;
    }
    
    @Input()
    set subjectCustomer(v) {
        if (v){
            this._contacto = v;
            if (v.customer){
                this._customer = v.customer;
                this.subjectCode = this._customer.code;
                //Si es para edición, se asumen valido
                this.subjectCodeValid = true;
                this.emailValid = true; 
                this.enEdicion = !this._customer.id;
            }
        }
    }
    get subjectCustomer() {
        return this._contacto;
    }
    
    @Input()
    set customer(c) {
        this._customer = c;
    }
    get customer() {
        return this._customer;
    }


    formSubjectCompleto() {
        return this.subjectCodeValid && this.emailValid;
    }
    async guardarContacto() {
        this.ui.limpiarMessages();

        if (this._customer .noTieneCorreoElectronico) {
            this.emailValid = true;
        }
        if (this._customer .esCedulaDiferenteAlRUC) {
            this._customer .nui = this.subjectNUI;
        } else {
            this._customer .nui = null;//esto forza para que el backend asigne el valor a partir del codigo
        }
        if (this._customer .esPersonaNatural) {
            this._contacto.customerSubjectType = 'NATURAL';
        } else {
            this._contacto.customerSubjectType = 'JURIDICA';
        }
        if (!this.formSubjectCompleto()) {
            this.ui.mostrarMensaje("error", `${this.appConfig.ux.formIvalid}`);
        } else {
            this._contacto.customer = this._customer ;
            if (this._contacto.customer) {
                this.contactosService.enviarContacto(this._contacto).subscribe(
                    async (data) => {
                        this._contacto = data;
                        this.cerrarPopup(true);
                    },
                    (err) => {
                        this.ui.mostrarError(err);
                    }
                );
            }
        }
    }


    handleChangeEsExtranjero($event) {
        if (!this.subjectCode) return;
        this.searchSubjectPorCode(event);
    }
    
    handleChangeEsCedulaDiferenteAlRUC(event) {
        this._customer .nui = '';
        this.etiquetaCIRUC = 'C.I/RUC';
        const checked = event.checked;
        if (checked){
            this.etiquetaCIRUC = 'RUC';
        }
    }
    
    handleChangeEsPersonalNatural(event) {
        const checked = event.checked;
        if (checked){
            this._customer .subjectType = 'NATURAL';
        } else {
            this._customer .subjectType = 'JURIDICA';
        }
    }
    

    /**
    * VErificar si el código ingresado esta registrado en la base de datos
    */
    async searchSubjectPorCode(event) {

        const datosActuales = this._customer ;
        this.ui.limpiarMessages();
        this.subjectCodeValid = false;
        let code: string = this.subjectCode ? this.subjectCode.toString() : "";

        this._customer  = new Subject(); //Encerar objeeto

        if (!code || code.length == 0) {
            return;
        }

        let isRUC: boolean = false;
        let isCI: boolean = false;
        let isPASSPORT: boolean = false;

        if (datosActuales.esExtranjero) {
            isPASSPORT = true;
            this.subjectCodeValid = true;
        } else {
            if (code && code.length == 10) {
                isCI = validateDni(code);
            } else if (code && code.length == 13) {
                isRUC = validateRUC(code);
            }
        }
        if (isCI || isRUC || isPASSPORT) {

            this.subjectCodeValid = true;

            let msg = "Verificando " + (isCI ? 'CI' : isRUC ? 'RUC' : (isPASSPORT ? 'PASAPORTE' : "")) + " Nº. " + code;
            this.verificandoData = this.ui.buildResultFromVerify(msg, this.appConfig.ux.messagesType.success);
            this.verificando = true;

            //Buscar si existe un usuario con ese code
            let data = await this.administracionService.getUserPorCodeData(code);
            if (data && data['personId']) {
                this._customer  = await this.contactosService.getContactoData(data['personId']);
                this._customer .usuarioOwner = true;
                this._customer .usuarioAPP = false;
                if (!this._customer .esPersonaNatural && this._customer .code.length == 10 && code.length == 10){
                    this._customer .esPersonaNatural = true;
                } else if (!this._customer .esPersonaNatural && this._customer .code.length == 13 && code.length == 10){
                    this._customer .esPersonaNatural = true; //forzar a persona natural por que esta buscando por cedula
                } else if (!this._customer .esPersonaNatural && this._customer .code.length == 13 && code.length == 13){
                    this._customer .esPersonaNatural = false; //forzar a persona natural por que esta buscando por cedula
                }
                this.verificando = false;
                this.subjectCodeValid = true;
                this.emailValid = true;
                this.subjectCode = code;
            } else {
                //Verificar si ya existe un contacto de esta organización con esa identificación,
                //para editarlo en lugar de crear un duplicado
                const contactoExistente = await this.contactosService.getContactoPorCodeYUsuarioConectadoData(code);
                if (contactoExistente && contactoExistente['id']) {
                    this.subjectCustomer = contactoExistente;
                    this.ui.mostrarMensaje("warn", `Ya tienes un contacto registrado con la identificación ${code}. Se cargaron sus datos para que puedas editarlo.`);
                } else {
                    this._customer  = datosActuales; //Volver lo digitado
                }
                this.verificando = false;
            }

        } else {
            //this._customer  = new Subject();
            this.verificando = false;
            this.ui.mostrarMensaje("error", `${this.appConfig.validationMsgs.cirucCustomerInvalid}`);
        }

        this._customer .code = code;
    }



    async searchEmailByCode(event) {

        //Validar sólo si es un correo del usuario
        this.emailValid = false;

        this.ui.limpiarMessages();
        if (this._customer .noTieneCorreoElectronico == true) {
            this.emailValid = true;
            return;
        }

        let code: string = this._customer .email.toString();

        if (!code || code.length == 0) {
            return;
        }

        let msg = "Verificando email " + code;
        this.verificandoData = this.ui.buildResultFromVerify(msg, this.appConfig.ux.messagesType.success);
        this.verificando = true;

        if (code) {
            let emailExistente = false;

            this.emailValid = validateEmail(code);

            if (this.emailValid) {
                emailExistente = await this.administracionService.getEmailPorCodeData(code);
                this.verificando = false;
            } else {
                this.verificando = false;
                this.ui.mostrarMensaje("warn", `El correo electrónico ${code} no tiene un formato válido. Corríjalo para continuar.`);
            }
            if (emailExistente && !this.enEdicion) {
                this.ui.mostrarMensaje("warn", `El correo electrónico ya se encuentra registrado. Si desea utilizar este correo, marque la casilla [¿Usa un correo electrónico de un familiar u otra persona?]`);
                this.emailValid = false; //No puede continuar con registro
            } else if (this.emailValid && !this._customer.id) {
                //Verificar si ya existe otro contacto con el mismo correo, para informar
                //al usuario antes de que el guardado falle por correo duplicado
                const contactoExistente = await this.contactosService.existeContactoPorEmailData(code);
                if (contactoExistente === true) {
                    this.ui.mostrarMensaje("warn", `Ya existe un contacto registrado con el correo electrónico ${code}. Verifique su lista de contactos o utilice otro correo.`);
                    this.emailValid = false; //No puede continuar con registro
                }
            }
        } else {
            this.verificando = false;
        }
    }
    
    cerrarPopup(guardado:boolean){
        this.visible = false;
        let mensaje = "Se cierra la venta de edición.";
        if ( guardado ){
            this.enEdicion = false;
            mensaje = "Se registró el Contacto/Cliente con éxito.";
        }
        const mode = !this._contacto.customerCode ? 'cedula' : this._contacto.customerCode.length == 10 ? "cedula" :  "ruc";
        this.contactoGuardado.emit({
              data: this._contacto,
              success: guardado,
              message: mensaje,
              mode: mode
            });
    }
}
